import { useState, useEffect } from "react";
import { Tooltip, IconButton, ClickAwayListener } from "@mui/material";
import { Comment } from "@mui/icons-material";

// auto-close like a native title tooltip
const AUTO_CLOSE_MS = 5000;

interface HeatCommentIconProps {
  comment?: string | null;
  heatName?: string;
  size?: "small" | "medium";
}

export const HeatCommentIcon = ({
  comment,
  heatName,
  size = "small",
}: HeatCommentIconProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => setOpen(false), AUTO_CLOSE_MS);
    return () => clearTimeout(timer);
  }, [open]);

  if (!comment) return null;

  // keep the tap target within the row so adjacent icons don't overlap
  const dims =
    size === "small"
      ? { icon: "20px", padding: "2px" }
      : { icon: "28px", padding: "6px" };

  const title = heatName ? `${heatName}: ${comment}` : comment;

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        title={title}
        arrow
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disableTouchListener
      >
        <IconButton
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            setOpen((prev) => !prev);
          }}
          sx={{ padding: dims.padding }}
        >
          <Comment color="primary" sx={{ fontSize: dims.icon }} />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
};
